export default {
  profileModel: state => state.profileModel,
  profileModelLoading: state => state.profileModel.$loading,
  profileData: state => state.profileModel.$serverData || {},
  profile: (state, getters) => getters.profileData,
  profileEmail: (state, getters) => getters.profile.email,
  profileDataLoading: state => state.profileModel.$loadingData,
  profileDataLoaded: state => state.profileModel.$dataLoaded,
  profileDataPromise: state => (
    state.profileModel.$dataLoadingPromise
    || state.profileDataPromiseTemp
  ),
  profileFullName: (state, getters) => {
    const firstName = getters.profile.first_name || '';
    const lastName = getters.profile.last_name || '';
    return `${firstName} ${lastName}`;
  },
  isPrivacyConfirmed: (state, getters) => Boolean(getters.profile.confirm_privacy),
  financialSituation: (state, getters) => getters.profileData.financial_situation,
  isFinancialSituationSpecified: (state, getters) => Boolean(getters.profileModel.isFinancialSituationSpecified),
  profileMetadata: (state, getters) => JSON.parse(getters.profileData?.meta) || {},
};
